<form [formGroup]="form" (ngSubmit)="save()">

  <!-- V2 Style - Floating Label -->
  <ng-container *ngIf="variant === 'v2'; else v3Style">
    <div class="form__group" [ngClass]="{'form__error': isSubmitted() && f[field.key].errors}">
      <div class="p-float-label">
        <p-dropdown (onChange)="save()" [options]="field.filteredOptions" [formControlName]="field.key" optionLabel="name" placeholder="Selecciona..."></p-dropdown>
        <label>{{field.label}}</label>
      </div>
      <span class="form__msgError" *ngIf="isSubmitted() && f[field.key].errors">
        <small class="p-error" *ngIf="f[field.key].hasError('required')">Requerido</small>
      </span>
    </div>
  </ng-container>

  <!-- V3 Style - Static Label -->
  <ng-template #v3Style>
    <div class="form__group">
      <label class="form__label pb-5" [for]="field.key">{{field.label}}</label>
      <p-dropdown
        (onChange)="save()"
        [options]="field.filteredOptions"
        [formControlName]="field.key"
        optionLabel="name"
        placeholder="Selecciona">
      </p-dropdown>
      <span class="form__msgError" *ngIf="isSubmitted() && f[field.key].errors">
        <small class="p-error" *ngIf="f[field.key].hasError('required')">Requerido</small>
      </span>
    </div>
  </ng-template>

</form>
